import formNames from '../../../constants/formNames';

const formName = formNames.order;

export const DUPLICATE_ORDER = `${formName}/DUPLICATE_ORDER`;
